module.exports = __webpack_public_path__ + "img/HUC-alt.b8aa2053.svg";